import React, { Component, Fragment } from 'react';
import { ErrorMessage, Form, Formik, Field } from 'formik';
import CustomLoader from '../../../common/CustomLoader';
import CustomSelect from '../../../../common/formElements/CustomSelect';
import CustomSelectWithValues from '../../../../common/formElements/CustomSelectWithValues';
import DynamicOpenModalRule from './DynamicOpenModalRule';
import {
  processRediretRule,
  getFilteredArray,
  collectionOptions,
  collectionFieldOptions,
  getPageOptions,
  getSelectOption,
  createActionSettingsSchema,
} from './util';
import { getFieldInfoByName } from '../collection/Util';
import FormFieldWithLabel from '../../../common/FormFieldWithLabel';
import { getPageComponents } from '../../../../common/utils/page_utils';
import { builderSurfaceJsonContentHeader } from '../../../../common/utils/restApiHeaderUtils';
import axios from 'axios';
import { FieldTypes } from 'drapcode-constant';
export default class DynamicOpenSubpage extends Component {
  state = { params: [], page: '' };

  componentDidMount = () => {
    const { eventAction } = this.props;
    const dbParams = eventAction.parameters.find((param) => param.name === 'subpageOpenRules');
    let params = [];
    if (dbParams && Array.isArray(dbParams.value) && dbParams.value.length > 0) {
      params = [
        ...dbParams.value,
        {
          id: dbParams.value.length + 1,
          fieldValue: '',
          modal: '',
        },
      ];
    } else {
      params = [
        {
          id: 1,
          fieldValue: '',
          modal: '',
        },
      ];
    }
    this.setState({ params });
  };

  componentDidUpdate(prevProps, prevState) {
    const { eventAction } = this.props;
    const dbParams = eventAction.parameters || [];
    const savedCollectionNameParam = dbParams.find((p) => p.name === 'collectionName');
    const savedFieldNameParam = dbParams.find((p) => p.name === 'fieldName');
    const savedCollectionName = savedCollectionNameParam ? savedCollectionNameParam.value : '';
    const savedFieldName = savedFieldNameParam ? savedFieldNameParam.value : '';
    if (
      savedCollectionName &&
      savedFieldName &&
      (prevState.collectionName !== savedCollectionName || prevState.fieldName !== savedFieldName)
    ) {
      this.restoreSavedFieldOptions(savedCollectionName, savedFieldName);
    }
  }

  restoreSavedFieldOptions = async (collectionName, fieldName) => {
    const options = await this.setCollectionValuesOptions({ collectionName, fieldName });
    this.setState({
      collectionName,
      fieldName,
      collectionFieldValueOptions: options,
    });
  };

  setCollectionValuesOptions = async (values) => {
    let options = [];
    const { projectId, version, events } = this.props;
    const { collections } = events;
    const selectedCollection = collections.find((e) => e.collectionName === values.collectionName);
    const selectedCollectionFields = selectedCollection ? selectedCollection.fields : [];
    const selectedField = selectedCollectionFields.find((e) => e.fieldName === values['fieldName']);
    if (!selectedField) {
      return [];
    }
    if (selectedField.type === FieldTypes.static_option.id) {
      selectedField.staticOptions.forEach((e) => options.push({ value: e, label: e }));
    } else if (selectedField.type === FieldTypes.dynamic_option.id) {
      const header = builderSurfaceJsonContentHeader(projectId);
      const { collectionName, collectionField } = selectedField.refCollection;
      await axios
        .get(`${process.env.REACT_APP_BUILDER_ENGINE}v${version}/items/${collectionName}/`, header)
        .then((res) => {
          if (res.data && res.data.content && Array.isArray(res.data.content)) {
            res.data.content.forEach((item) => {
              if (item[collectionField]) {
                options.push({
                  value: item[collectionField],
                  label: item[collectionField],
                });
              }
            });
          }
        });
    }
    return options;
  };

  createNewParamRow = (rowObj) => {
    const params = processRediretRule(this.state.params, rowObj);
    this.setState({ params });
  };

  handlePageChange = (setFieldValue, values, value) => {
    const { pages } = this.props.events;
    const selectedPage = pages.length > 0 ? pages.find((item) => item.slug === value) : null;
    const selectedPagCollection =
      selectedPage && selectedPage.collectionId ? selectedPage.collectionId : '';
    this.setState({ page: selectedPage });
    setFieldValue('collectionName', selectedPagCollection);
  };

  handleCollectionChange = (setFieldValue, values, value) => {
    setFieldValue('fieldName', '');
    this.setState({
      collectionName: value,
      fieldName: '',
      params: [
        {
          id: 1,
          fieldValue: '',
          modal: '',
        },
      ],
      collectionFieldValueOptions: [],
    });
  };

  handleFieldChange = async (name, value) => {
    const { collectionName } = this.state;
    const options = await this.setCollectionValuesOptions({
      collectionName,
      fieldName: value,
      params: [
        {
          id: 1,
          fieldValue: '',
          modal: '',
        },
      ],
    });
    this.setState({ collectionFieldValueOptions: options, fieldName: value });
  };

  onCollectionFromChange = (setFieldValue, values, value) => {
    if (value === 'session') {
      setFieldValue('collectionName', 'user');
    } else {
      setFieldValue('collectionName', '');
    }
    setFieldValue('collectionFrom', value);
    setFieldValue('fieldName', '');
    setFieldValue('page', '');
    this.setState({
      params: [
        {
          id: 1,
          fieldValue: '',
          modal: '',
        },
      ],
    });
  };

  getFormForRedirectRules = (values) => {
    const { events } = this.props;
    const { params, collectionFieldValueOptions } = this.state;
    const { snippets } = events;
    return (
      <div className="col-12">
        <label>
          Subpage Opening Rules{' '}
          {values['collectionFrom'] === 'sessionActionResponse' &&
            `(For default opening of subpage, use keyword DEFAULT or, EMPTY in Field Value)`}
        </label>
        <DynamicOpenModalRule
          createNewParamRow={this.createNewParamRow}
          params={params}
          collectionFrom={values['collectionFrom']}
          snippets={snippets}
          collectionFieldValueOptions={collectionFieldValueOptions}
          snippetType={'SUB_PAGE'}
        />
      </div>
    );
  };

  handleSubmit = (values) => {
    const { actionData } = this.props;
    const { params } = this.state;

    let parameters = [];
    Object.keys(values).map((value) => {
      const action = actionData.args.find((param) => {
        return param.name === value;
      });
      parameters.push({ name: value, value: values[value], type: action.type });
    });
    parameters.push({
      name: 'subpageOpenRules',
      value: getFilteredArray(params),
      type: 'array',
    });

    let actionFormData = this.props.eventAction;
    actionFormData.parameters = parameters;
    this.props.actions.updateAction({
      projectId: this.props.projectId,
      version: this.props.version,
      eventId: this.props.selectedEvent.uuid,
      data: actionFormData,
    });
    this.props.hideModal();
  };

  render() {
    const { eventAction, actionData } = this.props;
    const { page } = this.state;
    return (
      <Fragment>
        <Formik
          enableReinitialize={true}
          initialValues={createActionSettingsSchema(actionData, eventAction)}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            this.handleSubmit(values);
          }}
        >
          {({ isSubmitting, values, setFieldValue, setFieldTouched, errors }) => (
            <Form>
              <div className="row">
                <div className="col-12">
                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="Data Location"
                      icon="select"
                      infoIcon={true}
                      infoDescription={getFieldInfoByName('modalDataLocation')}
                    >
                      <CustomSelectWithValues
                        name={'collectionFrom'}
                        isMulti={false}
                        onChange={setFieldValue}
                        onBlur={setFieldTouched}
                        options={getSelectOption()}
                        value={values['collectionFrom']}
                        formValues={values}
                        setFieldValue={setFieldValue}
                        onChangeOption={this.onCollectionFromChange}
                        placeholder={'Get Data From'}
                      />
                      <ErrorMessage name={'collectionFrom'}>
                        {(msg) => <p className="text-error">{msg}</p>}
                      </ErrorMessage>
                    </FormFieldWithLabel>
                  </div>
                </div>
                {values['collectionFrom'] === 'page' && (
                  <div className="col-12">
                    <div className="form-group">
                      <FormFieldWithLabel
                        cta={false}
                        label="Page"
                        icon="select"
                        infoIcon={true}
                        infoDescription={getFieldInfoByName('modalCollectionPage')}
                      >
                        <CustomSelectWithValues
                          name={'page'}
                          isMulti={false}
                          onChange={setFieldValue}
                          onBlur={setFieldTouched}
                          options={getPageOptions(this.props.events)}
                          value={values['page']}
                          formValues={values}
                          setFieldValue={setFieldValue}
                          onChangeOption={this.handlePageChange}
                        />
                      </FormFieldWithLabel>
                    </div>
                  </div>
                )}
                {values['collectionFrom'] !== 'sessionActionResponse' && (
                  <>
                    <div className="col-12">
                      <div className="form-group">
                        <FormFieldWithLabel
                          cta={false}
                          label="Collection"
                          icon="select"
                          infoIcon={true}
                          infoDescription={getFieldInfoByName('modalDataLocationCollection')}
                        >
                          <CustomSelectWithValues
                            name={'collectionName'}
                            isMulti={false}
                            onChange={setFieldValue}
                            onBlur={setFieldTouched}
                            options={collectionOptions(this.props.events)}
                            value={values['collectionName']}
                            isDisabled={
                              values['collectionFrom'] === 'page' ||
                              values['collectionFrom'] === 'session'
                            }
                            formValues={values}
                            setFieldValue={setFieldValue}
                            onChangeOption={this.handleCollectionChange}
                          />
                        </FormFieldWithLabel>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-group">
                        <FormFieldWithLabel
                          cta={false}
                          label="Field"
                          icon="select"
                          infoIcon={true}
                          infoDescription={getFieldInfoByName('modalCollectionField')}
                        >
                          <CustomSelect
                            name={'fieldName'}
                            isMulti={false}
                            onChange={setFieldValue}
                            onBlur={setFieldTouched}
                            options={collectionFieldOptions(
                              values['collectionName'],
                              this.props.events,
                            )}
                            value={values['fieldName']}
                            onChangeValue={this.handleFieldChange}
                          />
                          <ErrorMessage name={'fieldName'}>
                            {(msg) => <p className="text-error">{msg}</p>}
                          </ErrorMessage>
                        </FormFieldWithLabel>
                      </div>
                    </div>
                  </>
                )}
                {values['collectionFrom'] === 'sessionActionResponse' && (
                  <div className="col-12">
                    <div className="form-group">
                      <FormFieldWithLabel
                        cta={false}
                        label="Session Field Name"
                        icon="text"
                        infoIcon={true}
                        infoDescription={getFieldInfoByName('modalSessionFieldName')}
                      >
                        <Field
                          type={'text'}
                          name={'fieldName'}
                          className="form-control form-control-sm"
                          autoComplete="off"
                          placeholder={'Field Name'}
                        />
                        <ErrorMessage name={'fieldName'}>
                          {(msg) => <p className="text-error">{msg}</p>}
                        </ErrorMessage>
                      </FormFieldWithLabel>
                    </div>
                  </div>
                )}
                {values['collectionFrom'] !== 'page' && (
                  <div className="col-12">
                    <div className="form-group">
                      <FormFieldWithLabel
                        cta={false}
                        label="Page"
                        icon="select"
                        infoIcon={true}
                        infoDescription={getFieldInfoByName('modalCollectionPage')}
                      >
                        <CustomSelectWithValues
                          name={'pageFrom'}
                          isMulti={false}
                          onChange={setFieldValue}
                          onBlur={setFieldTouched}
                          options={getPageOptions(this.props.events)}
                          value={values['pageFrom']}
                          formValues={values}
                          setFieldValue={setFieldValue}
                          onChangeOption={this.handlePageChange}
                        />
                      </FormFieldWithLabel>
                    </div>
                  </div>
                )}
                {this.state.page && (
                  <div className="col-12">
                    <div className="form-group">
                      <FormFieldWithLabel
                        cta={false}
                        label="Subpage Components"
                        icon="select"
                        infoIcon={true}
                        infoDescription={''}
                      >
                        <CustomSelectWithValues
                          name={'pageSubPageComponents'}
                          isMulti={false}
                          onChange={setFieldValue}
                          onBlur={setFieldTouched}
                          options={getPageComponents(page.content, ['sub-page'])}
                          value={values['pageSubPageComponents']}
                          formValues={values}
                          setFieldValue={setFieldValue}
                          //   onChangeOption={this.handlePageChange}
                        />
                      </FormFieldWithLabel>
                    </div>
                  </div>
                )}
                {values['fieldName'] &&
                  this.state.collectionFieldValueOptions &&
                  this.getFormForRedirectRules(values)}
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="text-right">
                    <div className="float-left">
                      <button
                        type="button"
                        className="btn btn-outline-secondary btn-sm"
                        onClick={this.props.hideModal}
                      >
                        <span>
                          <i className="wb webconnect-times"></i>&nbsp;Cancel
                        </span>
                      </button>
                    </div>
                    <div className="float-right">
                      <button type="submit" className="btn btn-theme-submit btn-sm">
                        <i className="wb webconnect-save-regular"></i>&nbsp;Save&nbsp;
                        <CustomLoader loading={this.props.showLoaderForAction} />
                      </button>
                    </div>
                    <div className="clearfix"></div>
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </Fragment>
    );
  }
}
